import { useEffect } from "react";

const useComponentDidMount = (callback: Function) => {
  useEffect(() => {
    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};

export default useComponentDidMount;
